module.exports = __webpack_public_path__ + "static/media/9.c357f4a5.jpg";